module.exports = __webpack_public_path__ + "img/icon1.c47e7438.png";